import { Box, Button, Stack } from '@mui/material'
import Admin from 'api/Admin'
import Input from 'components/Input'
import useForm from 'js/hooks/useForm'
import React, { useState } from 'react'
import { ModalBody } from 'react-bootstrap'
import { Modal } from 'reactstrap'


const schema = [
    {
        label: "First Name",
        name: "firstname",
        placeholder: "Enter first name",
        error: { required: true }
    },
    {
        label: "Last Name",
        name: "lastname",
        placeholder: "Enter last name",
        error: { required: true }
    },
    {
        label: "Phone",
        name: "phoneno",
        placeholder: "Eg: 9876543210",
        type: "tel",
        error: { name: "phone number", required: true, minlength: 10, maxlength: 10 }
    },
    {
        label: "Email",
        name: "email",
        placeholder: "Eg:user@email.com",
        error: { type: "email", required: true }
    },
    {
        label: "Address",
        name: "address",
        type: "textarea",
        placeholder: "Enter user address",
        error: { required: true, minlength: 10 }
    },
]


export default function AddUser({ onChange }) {


    const [payload, setPayload] = useState(false)
    const { data, inputProps, isError, setData, setTouched } = useForm({ schema, payload })

    const onCancel = () => setPayload(false)

    const onSubmit = async () => {

        if (isError()) {
            setTouched(true)
            return
        }
        try {
            const res = await Admin.Benefactor.register({ body: data })
            onChange && onChange(res)
            setPayload(false)
        } catch (error) {
            alert(error.message)
        }
    }

    return (
        <Box sx={{ display: "flex", justifyContent: "end" }}>
            <a onClick={() => setPayload(true)} className='a'>+ Beneficiary</a>
            <Modal isOpen={payload} toggle={onCancel}>
                <Box sx={{ borderBottom: "1px solid #0003", px: 2, pt: 1 }}>
                    <h3>Add New Beneficiary</h3>
                </Box>
                <ModalBody>
                    <Stack spacing={2}>
                        {schema.map(d => <Input {...inputProps(d)} />)}
                        <br />
                        <Stack flexDirection={"row"} justifyContent={"space-between"}>
                            <Button onClick={onCancel} variant='outlined' color='error'>Cancel</Button>
                            <Button onClick={onSubmit} variant='contained'>Submit</Button>
                        </Stack>
                    </Stack>
                </ModalBody>
            </Modal>
        </Box>
    )
}